import * as actionTypes from "../actionTypes";
import { setLoader } from "../Config/Users/users";

export const setTcsMultipleSelect = (
  multipleCity,
  multipleCenterName,
  multipleQualification,
  multipleRole
) => {
  return (dispatch) => {
    setLoader(true);
    dispatch({
      type: actionTypes.TCS_MULTIPLE_SELECT,
      multipleCity: multipleCity,
      multipleCenterName: multipleCenterName,
      multipleQualification: multipleQualification,
      multipleRole: multipleRole,
    });
    setLoader(false);
  };
};

export const setConfigureTable = (tableValue) => {
  return (dispatch) => {
    setLoader(true);
    dispatch({
      type: actionTypes.TCS_CONFIGURE_TABLE,
      tableValue: tableValue,
    });
    setLoader(false);
  };
};
